import { DtoRequestLoasPostReq } from "./abst/DtoRequestLoasPostReq";
import { EntityRequest } from "../entity/EntityRequest";

export class DtoRequestLoasPostReqImple extends DtoRequestLoasPostReq {
  public request = new EntityRequest();

  public IsValidImple(chkPager: boolean): string[] {
    let res: string[] = new Array();
    //ページャー用入力値チェック

    return res;
  }
}
